import { render, staticRenderFns } from "./DeviceSection.vue?vue&type=template&id=5074d9fa"
import script from "./DeviceSection.vue?vue&type=script&lang=ts"
export * from "./DeviceSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports